import React from 'react'
import {
  Box,
  Card,
  styled
} from '@mui/material';
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  AreaChart,
  Area,
  ResponsiveContainer,
} from 'recharts';
import { useLastSavenDaysCustomer } from '../../../requests/dashboard';
import useAuth from '../../../hooks/useAuth';


const CardRoot = styled(Card)(({ theme }) => ({
  marginBottom: '24px',
  padding: '24px !important',
  [theme.breakpoints.down('sm')]: { paddingLeft: '16px !important' },
}));


const Title = styled('span')(() => ({
  fontSize: '1rem',
  fontWeight: '500',
  textTransform: 'capitalize',
}));

const CustomerStates = () => {

  const { data: lastSavenDaysData } = useLastSavenDaysCustomer();
  const user = useAuth();

  if (user?.user?.service_area_id) {
    return <></>
  }



  return (
    <>
      <CardRoot className="__seven_days_customer_stats">
        <Title style={{ paddingLeft: -25, }}>Last seven days user data</Title>


        <Box className="__seven_days_customer_stats" >
          <div style={{ marginTop: 20 }}>
            <ResponsiveContainer width="100%" height={200}>
              <AreaChart
                width={500}
                height={200}
                data={lastSavenDaysData || []}
                syncId="anyId"
                margin={{
                  top: 10,
                  right: 30,
                  left: 0,
                  bottom: 0,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Area type="monotone" dataKey="user" stroke="#4caf50" fill="#4caf50" />

              </AreaChart>
            </ResponsiveContainer>
          </div>

        </Box>

      </CardRoot >

    </>
  )
}

export default CustomerStates